<template>
    <ProgressLevel />
</template>

<script>
import ProgressLevel from './ProgressLevel.vue'
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

export default {
    name: 'ProgressLevelIndex',
    components: { ProgressLevel },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [{title: "Tiến trình Level", icon: 'fas fa-chart-line'}]);
    },
}
</script>
